// RegisterPatient.jsx
import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { doc, setDoc, Timestamp } from "firebase/firestore";

import { QRCodeSVG } from 'qrcode.react';
import { v4 as uuidv4 } from "uuid";

export default function RegisterPatient() {
  const [formData, setFormData] = useState({
    preferredName: "",
    dateCompleted: "",
    fullName: "",
    dob: "",
    address: "",
    healthNumber: "",
    summary: "",
    otherDocs: "",
    legalProxy: "No",
    whatValue: "",
    whatFear: "",
    capacity: "Yes",
    lackCapacityReason: "",
    involvement: "A",
    involvementOther: "",
    clinicians: [{ grade: "", name: "", number: "", signature: "", dateTime: "" }],
    emergencyContacts: [{ name: "", role: "", contactNo: "", signature: "" }]
  });
  const [token, setToken] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleArrayChange = (index, field, value, section) => {
    const updated = [...formData[section]];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, [section]: updated }));
  };

  const addRow = (section) => {
    const row = section === "clinicians"
      ? { grade: "", name: "", number: "", signature: "", dateTime: "" }
      : { name: "", role: "", contactNo: "", signature: "" };
    setFormData((prev) => ({ ...prev, [section]: [...prev[section], row] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newToken = uuidv4();
    const patientRef = doc(db, "patients", newToken);
    await setDoc(patientRef, {
      ...formData,
      createdAt: Timestamp.now()
    });
    setToken(newToken);
  };

  return (
    <div className="register-patient">
      <h2>Register New Patient</h2>
      <form onSubmit={handleSubmit}>
        <input name="preferredName" placeholder="Preferred name" required onChange={handleChange} />
        <input name="dateCompleted" type="date" required onChange={handleChange} />
        <input name="fullName" placeholder="Full name" required onChange={handleChange} />
        <input name="dob" type="date" required onChange={handleChange} />
        <input name="address" placeholder="Address" required onChange={handleChange} />
        <input name="healthNumber" placeholder="NHS/CHI/Health and care number" required onChange={handleChange} />

        <textarea name="summary" placeholder="Summary of health and condition" required onChange={handleChange} />
        <textarea name="otherDocs" placeholder="Details of other care planning documents" required onChange={handleChange} />

        <label>Legal welfare proxy in place?</label>
        <select name="legalProxy" value={formData.legalProxy} onChange={handleChange} required>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>

        <textarea name="whatValue" placeholder="What I most value" required onChange={handleChange} />
        <textarea name="whatFear" placeholder="What I most fear / wish to avoid" required onChange={handleChange} />

        <label>Does the person have capacity?</label>
        <select name="capacity" value={formData.capacity} onChange={handleChange} required>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        {formData.capacity === "No" && (
          <textarea name="lackCapacityReason" placeholder="If no, in what way?" required onChange={handleChange} />
        )}

        <label>Involvement in making this plan</label>
        <select name="involvement" value={formData.involvement} onChange={handleChange} required>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
        </select>
        {formData.involvement === "D" && (
          <textarea name="involvementOther" placeholder="If D, specify reason" required onChange={handleChange} />
        )}

        <h3>Clinicians' Signatures</h3>
        {formData.clinicians.map((c, i) => (
          <div key={i}>
            <input placeholder="Grade" required onChange={(e) => handleArrayChange(i, "grade", e.target.value, "clinicians")} />
            <input placeholder="Name" required onChange={(e) => handleArrayChange(i, "name", e.target.value, "clinicians")} />
            <input placeholder="GMC/NMC/HCPC no." required onChange={(e) => handleArrayChange(i, "number", e.target.value, "clinicians")} />
            <input placeholder="Signature" required onChange={(e) => handleArrayChange(i, "signature", e.target.value, "clinicians")} />
            <input type="datetime-local" required onChange={(e) => handleArrayChange(i, "dateTime", e.target.value, "clinicians")} />
          </div>
        ))}
        <button type="button" onClick={() => addRow("clinicians")}>+ Add Clinician</button>

        <h3>Emergency Contacts</h3>
        {formData.emergencyContacts.map((c, i) => (
          <div key={i}>
            <input placeholder="Name" required onChange={(e) => handleArrayChange(i, "name", e.target.value, "emergencyContacts")} />
            <input placeholder="Role & relationship" required onChange={(e) => handleArrayChange(i, "role", e.target.value, "emergencyContacts")} />
            <input placeholder="Contact number" required onChange={(e) => handleArrayChange(i, "contactNo", e.target.value, "emergencyContacts")} />
            <input placeholder="Signature" required onChange={(e) => handleArrayChange(i, "signature", e.target.value, "emergencyContacts")} />
          </div>
        ))}
        <button type="button" onClick={() => addRow("emergencyContacts")}>+ Add Emergency Contact</button>

        <button type="submit">Register Patient</button>
      </form>

      {token && (
  <div>
    <h3>Patient Registered!</h3>
    <p>Token: {token}</p>
    <QRCodeSVG value={`${window.location.origin}/patient/${token}`} />
  </div>
)}
    </div>
  );
}